import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type DeleteWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteWebhookInput;
}>;

export type DeleteWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsDeleteWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteWebhookPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteWebhookDocument = gql`
  mutation deleteWebhook($input: DeleteWebhookInput!) {
    webhookSubscriptionsDeleteWebhook(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
